// extracted by mini-css-extract-plugin
module.exports = {"grade-list":"grade-list_x1Un","tabs":"tabs_1MZ7","grade-scroll":"grade-scroll_3-Bn","grade-item":"grade-item_4jkR","intro":"intro_1d5Y","tab":"tab_cryA","active":"active_1YtG"};